import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { AuthService } from '@core/services/auth.service';

declare const io: any;

@Injectable({
  providedIn: 'root',
})
export class DriversTrackingService {
  socket: any;

  constructor(private authService: AuthService) {
    this.socket = io(environment.socket_url, {
      transports: ['websocket'],
      query: {
        token: `Bearer ${this.authService.currentUser$.value.accessToken}`,
      },
    });
  }

  listen(eventName: string): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      });

      return (): void => {
        this.socket.removeAllListeners();
        this.socket.disconnect();
      };
    });
  }
}
